<template>
  <tabs
    v-if="departure.id"
    :tab-name="tabs"
    :tab-icon="icons"
    nav-pills-icons
    color-button="primary"
  >
    <template
      v-for="(item, index) in tabData"
      :slot="'tab-pane-' + (index + 1)"
    >
      <component
        v-bind:is="item.comp"
        v-bind:departure="departure"
        :key="item.name"
      ></component>
    </template>
  </tabs>
</template>
<script>
import { Tabs } from "@/components";
import DepartureTabsBooking from "./DepartureTabsBooking.vue";
import DepartureTabsTickets from "./DepartureTabsTickets.vue";
import DepartureTabsExtras from "./DepartureTabsExtras.vue";
import DepartureTabsGuides from "./DepartureTabsGuides.vue";
import DepartureTabsEmail from "./DepartureTabsEmail.vue";
import DepartureTabsNotes from "./DepartureTabsNotes.vue";

import _filter from "lodash/filter";
import _map from "lodash/map";

export default {
  props: ["departure"],

  components: {
    Tabs,
    DepartureTabsBooking,
    DepartureTabsTickets,
    DepartureTabsExtras,
    DepartureTabsGuides,
    DepartureTabsEmail,
    DepartureTabsNotes
  },

  computed: {
    tabData() {
      let data = [
        {
          name: "Bookings",
          icon: "event_available",
          allowed: true,
          comp: "DepartureTabsBooking"
        },
        {
          name: "Tickets",
          icon: "sell",
          allowed:
            this.$allowed(["tour.price.manage", "tour.price.view.all"]) &&
            this.tourType != "tour",
          comp: "DepartureTabsTickets"
        },
        {
          name: "Extras",
          icon: "person_add_alt_1",
          allowed: this.$allowed(["tour.extra.manage", "tour.extra.view.all"]),
          comp: "DepartureTabsExtras"
        },
        {
          name: "Guides",
          icon: "explore",
          allowed:
            this.$allowed(["tour.guide.manage", "tour.guide.view.all"]) &&
            this.tourType == "tour",
          comp: "DepartureTabsGuides"
        },
        {
          name: "Email",
          icon: "alternate_email",
          allowed: this.$allowed(["tour.guide.manage", "tour.email.view.all"]),
          comp: "DepartureTabsEmail"
        },
        {
          name: "Notes",
          icon: "text_snippet",
          allowed: this.$allowed(["note.tour.manage", "note.tour.view.all"]),
          comp: "DepartureTabsNotes"
        }
      ];
      return _filter(data, { allowed: true });
    },
    tabs() {
      return _map(this.tabData, "name");
    },
    icons() {
      return _map(this.tabData, "icon");
    },
    tourType() {
      return this.departure.tour?.type?.value;
    }
  }
};
</script>
